import React from 'react';
import { Layout, Select, Row, Col, theme } from 'antd';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import PoweroffOutlined from '@ant-design/icons/PoweroffOutlined';
import { isEmpty } from 'lodash';

import HeaderSearch from './HeaderSearch';
import { useTheme } from '../shared/hooks'
import { API } from '../../AxiosWrapper';

const { Option } = Select;
const { Header } = Layout;

const SiteHeader = ({
  user, branchId, branches, locale, handleBranchChange, setLocale, setUserTheme
}) => {
  const intl = useIntl()
  const history = useHistory()
  const antTheme = useTheme()
  const {
    token: { colorBgContainer }
  } = theme.useToken()

  const handleLocaleChange = locale => {
    setLocale(locale)
    localStorage.setItem('locale', locale)
  }

  const handleThemeChange = theme => {
    setUserTheme(theme)
    localStorage.setItem('userTheme', theme)
  }

  const handleUserMenu = key => {
    if (key === 'logout')
      API.logout();
    if (key === 'profile')
      history.push('/settings/profile')
    if (key === 'lang')
      handleLocaleChange(locale === 'en' ? 'is' : 'en')
    if (key === 'theme')
      handleThemeChange(antTheme === 'dark' ? 'light' : 'dark')
  }

  const menuItems = [
    {
      key: 'profile',
      label: <FormattedMessage id="Header.Profile" />,
    },
    {
      key: 'lang',
      label: locale === 'en' ? 'Íslenska' : 'English'
    },
    {
      key: 'theme',
      label: <FormattedMessage id={antTheme === 'dark' ? 'Theme.LightMode' : 'Theme.DarkMode'} />
    },
    {
      key: 'logout',
      label: <><PoweroffOutlined />{' '}<FormattedMessage id="Header.Logout" /></>,
    }
  ];

  return (
    <Header style={{ background: colorBgContainer }}>
      <Row>
        <Col xs={24} lg={12}>
          {user && !isEmpty(branches)
            ? (
              <Select
                value={branchId}
                onSelect={handleBranchChange}
                className="header-item"
              >
                {branches.length > 1 &&
                  <Option key={0} value={0}>
                    <FormattedMessage id="Header.AllBranches" />
                  </Option>
                }
                {branches.map((branch) => (
                  <Option key={branch.id} value={branch.id}>
                    {branch.name}
                  </Option>
                ))}
              </Select>
            ) : (
              <Select
                disabled
                placeholder={intl.formatMessage({ id: 'Branch.Unavailable' })}
                className="header-item"
              />
            )}
        </Col>

        <Col xs={24} lg={6}><HeaderSearch /></Col>

        <Col xs={24} lg={6} style={{ textAlign: 'right' }}>
          {user && (
            <Select
              value={user.firstName}
              onSelect={handleUserMenu}
              className="header-item"
              style={{ textAlign: 'left' }}
            >
              {menuItems.map((item) => (
                <Option key={item.key} value={item.key}>
                  {item.label}
                </Option>
              ))}
            </Select>
          )}
        </Col>
      </Row>
    </Header>
  )
}

export default SiteHeader
